import React, { useEffect } from 'react'
import MerckDropdown from '../../../shared/merckDropdown/merckDropdown'
import { useDispatch, useSelector } from 'react-redux'
import { ACCOUNTS, CONTRACTTEMPLATE } from '../../../constants/accountSummaryConstant'
import {
  updateselectedAccountSummaryHeaderAccountDD,
  updateselectedAccountSummaryHeaderContractDD,
  updateAccountSummaryHeaderAccountDDOptions,
  UpdateRfpData,
  updateAccountSummaryHeadercontractDDOptions
} from '../../../reducer/accountSummary/accountSummarySlice'
import './accountSummaryHeader.scss'
import {
  setEnableBackgroundCalc,
  setIsScenarioChangesDetectedFlag,
  updateSendContractStructureTemplateIdCustomerPov
} from '../../../reducer/CommonSlice'

const AccountSummaryHeaderDDs = ({
  accountsDropdown,
  contractStructureValue,
  accountDropdownDefault,
  contractStructureDefault,
  callCustomerPOV
}) => {
  const dispatch = useDispatch()

  const accountDropdownOptions = useSelector(
    (state) => state.AccountSummary.AccountSummaryHeaderAccountDDOptions
  )
  const cstDefaultValue = useSelector((state) => state.AccountSummary.cstDefaultValue)
  const accountDefaultValue = useSelector((state) => state.AccountSummary.accountDefaultValue)

  const selectedAccountDropdown = useSelector(
    (state) => state.AccountSummary.SelectedAccountSummaryHeaderAccountDD
  )
  const selectedContractTypeDropdown = useSelector(
    (state) => state.AccountSummary.SelectedAccountSummaryHeaderContractDD
  )
  const RfpData = useSelector((state) => state.AccountSummary.RfpData)
  const contractTypeDropdownOptions = useSelector(
    (state) => state.AccountSummary.AccountSummaryHeadercontractDDOptions
  )

  const is_refresh = useSelector((state) => state.Common.is_refresh)

  useEffect(() => {
    dispatch(
      updateAccountSummaryHeaderAccountDDOptions(
        accountsDropdown?.accounts?.length > 0
          ? accountsDropdown.accounts.map((account) => ({
              value: account.account_or_corporate_id,
              label: account.account_or_corporate_name
            }))
          : []
      )
    )
  }, [accountsDropdown.accounts])

  useEffect(() => {
    const ContractTemplateValues = []
    contractStructureValue?.forEach((template) => {
      ContractTemplateValues.push({
        value: template.contract_offered_id,
        label: template.contract_offered
      })
    })

    dispatch(updateAccountSummaryHeadercontractDDOptions(ContractTemplateValues))
  }, [contractStructureValue])

  const defaultCst = contractTypeDropdownOptions.filter(
    (contractStructure) => contractStructureDefault === contractStructure.value
  )

  const handleDropDownValueChange = (e, value, type) => {
    let valueData = { value: value.value, label: value.label }

    if (e) {
      // eslint-disable-next-line default-case
      switch (type) {
        case ACCOUNTS:
          dispatch(setEnableBackgroundCalc(false))
          dispatch(updateSendContractStructureTemplateIdCustomerPov(false))
          dispatch(updateselectedAccountSummaryHeaderAccountDD(valueData))
          // Emptying Contract Dropdown in case of Account Change
          dispatch(updateselectedAccountSummaryHeaderContractDD({}))
          dispatch(setIsScenarioChangesDetectedFlag(true))
          setTimeout(
            callCustomerPOV({
              account_or_corporate_id: value.value
            }),
            500
          )
          break
        case CONTRACTTEMPLATE:
          dispatch(setEnableBackgroundCalc(false))
          dispatch(updateselectedAccountSummaryHeaderContractDD(valueData))
          dispatch(
            UpdateRfpData({
              Title: 'RFP Approval Outputs',
              data: RfpData.data.map((item) =>
                item.title === 'Current Contract' ? { ...item, value: valueData.label } : item
              )
            })
          )
          dispatch(setIsScenarioChangesDetectedFlag(true))
          setTimeout(
            callCustomerPOV({
              contract_structure_template_id: value.value
            }),
            500
          )
          break
      }
    }
  }

  return (
    <div style={{ display: 'flex', gap: '12px' }}>
      <div className="dropdownContainers">
        <span className="dropdown-text">Account</span>
        <MerckDropdown
          options={JSON.parse(JSON.stringify(accountDropdownOptions)).sort((a, b) => {
            const sorted = a.label.localeCompare(b.label)
            return sorted
          })}
          placeholder="Select.."
          showSearch={true}
          allowClear={false}
          value={selectedAccountDropdown.label}
          disabled={is_refresh === 'Y' || is_refresh === 'D'}
          defaultValue={accountDefaultValue?.label || 'Loading...'}
          onChange={(e, val) => handleDropDownValueChange(e, val, ACCOUNTS)}
          name
          className="dropdown-align account-summary-dropdown"
        ></MerckDropdown>
      </div>

      <div className="dropdownContainers">
        <span className="dropdown-text">Contract Structure Template</span>
        <MerckDropdown
          options={JSON.parse(JSON.stringify(contractTypeDropdownOptions)).sort((a, b) => {
            const sorted = a.label.localeCompare(b.label)
            return sorted
          })}
          placeholder="Select.."
          showSearch={true}
          allowClear={false}
          disabled={is_refresh === 'Y' || is_refresh === 'D'}
          value={selectedContractTypeDropdown.label}
          defaultValue={cstDefaultValue?.label || 'Loading...'}
          onChange={(e, val) => handleDropDownValueChange(e, val, CONTRACTTEMPLATE)}
          name
          className="dropdown-align account-summary-dropdown"
        ></MerckDropdown>
      </div>
    </div>
  )
}

export default AccountSummaryHeaderDDs
